import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
  AppBarWide,
  AppBarWideValue,
  FlyoutTileHeight,
  FlyoutTileIconSize,
  FlyoutTileWidth,
  TileHeightMercury,
  TileHeightWide,
  TileWidthMercury,
} from "./Constants";
export const useIconStyles = makeStyles({
  tile: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "none",
  },
  wideTile: {
    width: AppBarWide,
    height: TileHeightWide,
  },
  flyoutTile: {
    width: FlyoutTileWidth,
    height: FlyoutTileHeight,
  },
  mercuryDesignTile: {
    height: TileHeightMercury,
    width: TileWidthMercury,
  },
  flyoutIcon: {
    display: "flex",
    flexDirection: "column",
    width: FlyoutTileIconSize,
    height: FlyoutTileIconSize,
    minHeight: FlyoutTileIconSize,
    alignItems: "center",
    marginBottom: "4px",
  },
  flyoutIconMatted: {
    ...shorthands.border("1px", "solid"),
    justifyContent: "center",
    ...shorthands.borderRadius("6px"),
    ...shorthands.borderColor(tokens.colorNeutralStroke2),
  },
  label: {
    display: "block",
    width: AppBarWideValue - 8 + "px", // reserve pixels on each side so label won't overlap with tile selector
    ...shorthands.margin("0px", "7px"),
    ...shorthands.overflow("hidden"),
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    textAlign: "center",
    lineHeight: tokens.lineHeightBase100,
    alignItems: "center",
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase100,
  },
  flyoutLabel: {
    width: "92px",
    height: "32px",
    fontSize: tokens.fontSizeBase200,
    wordBreak: "break-word",
    "@supports (-webkit-line-clamp: 2)": {
      whiteSpace: "break-spaces",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      height: "30px",
      marginBottom: "2px",
    },
  },
  flyoutIconImageFullBleed: {
    ...shorthands.border("1px", "solid"),
    ...shorthands.borderRadius("6px"),
    ...shorthands.borderColor(tokens.colorNeutralStroke2),
  },
  tileImageFullBleed: {
    ...shorthands.borderRadius("4px"),
  },
  outlineIconFilter: {
    height: "0px",
    width: "0px",
  },
  floodFillIfHighContrast: {
    "@media (forced-colors: active)": {
      // system-color for specifying the text color of a button as specified from OS
      floodColor: "ButtonText",
    },
  },
});
